import { render, staticRenderFns } from "./PropertiesCover.vue?vue&type=template&id=4fa4fd6f"
import script from "./PropertiesCover.vue?vue&type=script&lang=js"
export * from "./PropertiesCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports